export default "__VITE_ASSET__CzcCdxgn__"